import { render } from "./BindPost.vue?vue&type=template&id=4ab6e272"
import script from "./BindPost.vue?vue&type=script&lang=js"
export * from "./BindPost.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__